import { useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";

import { COMPONENTS, DEFAULT } from "./components";
import type { FormPropsType } from "./types";

type PropsType<T> =
  | { name: "list" | "new" | "edit" | "show" | "export" | "audit" | "offers" | "products" }
  | ({ name: "form" } & FormPropsType<T>);

export default function SpecificComponent<T>({ name, ...props }: PropsType<T>) {
  const { currentCustomer, currentProject } = useAppSelector(sessionSelector);

  const Component: any =
    COMPONENTS[currentCustomer.identifier]?.[currentProject.identifier]?.[name] ||
    COMPONENTS[currentCustomer.identifier]?.default?.[name] ||
    DEFAULT[name];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
}
